"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clientsUtils = __importStar(require("@mulesoft/exchange-clients-commons"));
var debug_1 = __importDefault(require("debug"));
var isomorphic_form_data_1 = __importDefault(require("isomorphic-form-data"));
var timeUtils = __importStar(require("./utils/time"));
var log = (0, debug_1.default)('exchange:asset:service');
var DEFAULT_ASSETS_LIMIT = 20;
var AssetService = /** @class */ (function (_super) {
    __extends(AssetService, _super);
    function AssetService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function (_a) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([_a], args_1, true), void 0, function (_b, _c) {
                var pathname, url, formData, headers, body, _d, contentType, response, json;
                var context = _b.context, organizationId = _b.organizationId, groupId = _b.groupId, assetId = _b.assetId, version = _b.version, apiVersion = _b.apiVersion, apiGroupVersion = _b.apiGroupVersion, assetLink = _b.assetLink, name = _b.name, main = _b.main, classifier = _b.classifier, asset = _b.asset, allowedAPISpecFormats = _b.allowedAPISpecFormats;
                var _e = _c === void 0 ? {} : _c, _f = _e.retries, retries = _f === void 0 ? 0 : _f, _g = _e.waitSlotTime, waitSlotTime = _g === void 0 ? 500 : _g, _h = _e.timeout, timeout = _h === void 0 ? 0 : _h;
                return __generator(this, function (_j) {
                    switch (_j.label) {
                        case 0:
                            pathname = '/api/v1/assets';
                            url = this.getAPIUrl({
                                context: context,
                                pathname: pathname
                            });
                            log('Creating asset', {
                                organizationId: organizationId,
                                groupId: groupId,
                                assetId: assetId,
                                version: version,
                                apiVersion: apiVersion,
                                apiGroupVersion: apiGroupVersion,
                                assetLink: assetLink,
                                name: name,
                                main: main,
                                classifier: classifier,
                                asset: asset
                            });
                            formData = new isomorphic_form_data_1.default();
                            formData.append('organizationId', organizationId);
                            formData.append('groupId', groupId);
                            formData.append('assetId', assetId);
                            formData.append('version', version);
                            formData.append('name', name);
                            formData.append('classifier', classifier);
                            if (apiVersion) {
                                formData.append('apiVersion', apiVersion.trim());
                            }
                            if (apiGroupVersion) {
                                formData.append('apiGroupVersion', apiGroupVersion.trim());
                            }
                            if (assetLink) {
                                formData.append('assetLink', assetLink.trim());
                            }
                            if (main) {
                                formData.append('main', main.trim());
                            }
                            if (asset) {
                                formData.append('asset', asset);
                            }
                            headers = allowedAPISpecFormats
                                ? {
                                    'x-allowed-api-spec-formats': JSON.stringify(allowedAPISpecFormats)
                                }
                                : {};
                            if (!(retries === 0)) return [3 /*break*/, 1];
                            _d = formData;
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, clientsUtils.getBufferedFormData(formData)];
                        case 2:
                            _d = _j.sent();
                            _j.label = 3;
                        case 3:
                            body = _d;
                            contentType = clientsUtils.isClient()
                                ? null
                                : "multipart/form-data; boundary=".concat(formData.getBoundary());
                            return [4 /*yield*/, this.fetch(url, {
                                    context: context,
                                    retries: retries,
                                    waitSlotTime: waitSlotTime,
                                    timeout: timeout,
                                    method: 'POST',
                                    body: body,
                                    headers: __assign(__assign({}, headers), { 'content-type': contentType })
                                })];
                        case 4:
                            response = _j.sent();
                            return [4 /*yield*/, response.json()];
                        case 5:
                            json = _j.sent();
                            return [2 /*return*/, json];
                    }
                });
            });
        };
        _this.getMainFiles = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var pathname, url, response, json;
            var context = _b.context, file = _b.file, classifier = _b.classifier;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pathname = "/api/v1/files/classifiers/".concat(classifier, "/entries/main");
                        url = this.getAPIUrl({
                            context: context,
                            pathname: pathname
                        });
                        return [4 /*yield*/, this.fetch(url, {
                                context: context,
                                method: 'POST',
                                body: file,
                                headers: {
                                    'content-type': 'application/zip'
                                }
                            })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = (_c.sent());
                        return [2 /*return*/, json];
                }
            });
        }); };
        _this.getOrganizationGroupIds = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var pathname, url, response, json;
            var context = _b.context, organizationId = _b.organizationId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pathname = "/api/v1/organizations/".concat(organizationId, "/groups");
                        url = this.getAPIUrl({
                            context: context,
                            pathname: pathname
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _c.sent();
                        return [2 /*return*/, json.map(function (_a) {
                                var groupId = _a.groupId;
                                return groupId;
                            })];
                }
            });
        }); };
        _this.getFacets = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var pathname, url, response, json;
            var context = _b.context, query = _b.query, organizationId = _b.organizationId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pathname = "/api/v2/".concat(organizationId ? "organizations/".concat(organizationId, "/") : '', "facets");
                        url = this.getAPIUrl({
                            context: context,
                            pathname: pathname,
                            query: query
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _c.sent();
                        return [2 /*return*/, json];
                }
            });
        }); };
        _this.getList = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var pathname, url, response, json;
            var context = _b.context, _c = _b.search, search = _c === void 0 ? '' : _c, _d = _b.organizationId, organizationId = _d === void 0 ? [] : _d, _e = _b.masterOrganizationId, masterOrganizationId = _e === void 0 ? '' : _e, _f = _b.domain, domain = _f === void 0 ? '' : _f, _g = _b.type, type = _g === void 0 ? [] : _g, _h = _b.offset, offset = _h === void 0 ? 0 : _h, _j = _b.limit, limit = _j === void 0 ? DEFAULT_ASSETS_LIMIT : _j, _k = _b.includeSnapshots, includeSnapshots = _k === void 0 ? true : _k, sharedWithMe = _b.sharedWithMe;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        if (domain) {
                            pathname = "/api/v2/organizations/".concat(domain, "/assets");
                        }
                        else {
                            pathname = '/api/v2/assets';
                        }
                        url = this.getAPIUrl({
                            context: context,
                            query: {
                                search: search,
                                types: type,
                                domain: domain,
                                organizationId: organizationId,
                                masterOrganizationId: masterOrganizationId,
                                offset: offset,
                                limit: limit,
                                sharedWithMe: sharedWithMe,
                                includeSnapshots: includeSnapshots
                            },
                            pathname: pathname
                        });
                        log('Getting assets list', {
                            search: search,
                            organizationId: organizationId,
                            masterOrganizationId: masterOrganizationId,
                            domain: domain,
                            type: type,
                            offset: offset,
                            limit: limit,
                            context: context,
                            includeSnapshots: includeSnapshots,
                            pathname: pathname
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context })];
                    case 1:
                        response = _l.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _l.sent();
                        return [2 /*return*/, json];
                }
            });
        }); };
        _this.get = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var query, url, response, json;
            var context = _b.context, domain = _b.domain, groupId = _b.groupId, assetId = _b.assetId, version = _b.version, status = _b.status, strict = _b.strict, minorVersion = _b.minorVersion;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        query = {};
                        if (status) {
                            query.status = status;
                        }
                        if (strict !== undefined) {
                            query.strict = strict;
                        }
                        url = this.getAPIUrl({
                            context: context,
                            pathname: "/api/v2".concat(domain ? "/portals/".concat(domain) : '', "/assets/").concat(groupId, "/").concat(assetId).concat(minorVersion
                                ? "/minorVersions/".concat(minorVersion)
                                : "".concat(version ? "/".concat(version) : '')),
                            query: query
                        });
                        log('Getting asset', {
                            groupId: groupId,
                            assetId: assetId,
                            version: version
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _c.sent();
                        return [2 /*return*/, json];
                }
            });
        }); };
        _this.updateIcon = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url, response, json;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, iconFile = _b.iconFile;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = this.getAPIUrl({
                            context: context,
                            pathname: "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/icon")
                        });
                        return [4 /*yield*/, this.fetch(url, {
                                context: context,
                                method: 'PUT',
                                headers: { 'content-type': iconFile.type || 'image/png' },
                                body: iconFile
                            })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _c.sent();
                        return [2 /*return*/, json];
                }
            });
        }); };
        _this.deleteIcon = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = this.getAPIUrl({
                            context: context,
                            pathname: "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/icon")
                        });
                        return [4 /*yield*/, this.fetch(url, {
                                context: context,
                                method: 'DELETE'
                            })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.remove = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url, assetDeleteType;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, version = _b.version, createdAt = _b.createdAt, deleteType = _b.deleteType;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = this.getAPIUrl({
                            context: context,
                            pathname: "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/").concat(version)
                        });
                        if (createdAt && !deleteType) {
                            assetDeleteType = timeUtils.isWithinDeleteTimeLimit(createdAt)
                                ? 'hard-delete'
                                : 'soft-delete';
                        }
                        else if (deleteType) {
                            assetDeleteType = "".concat(deleteType, "-delete");
                        }
                        else {
                            assetDeleteType = 'soft-delete';
                        }
                        log('Removing asset', {
                            groupId: groupId,
                            assetId: assetId,
                            version: version
                        });
                        return [4 /*yield*/, this.fetch(url, {
                                context: context,
                                method: 'DELETE',
                                headers: {
                                    'x-delete-type': assetDeleteType
                                }
                            })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.updateStatus = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var url, context, groupId, assetId, status, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = params.context, groupId = params.groupId, assetId = params.assetId, status = params.status;
                        if ('version' in params) {
                            url = this.getAPIUrl({
                                context: context,
                                pathname: "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/").concat(params.version, "/status")
                            });
                            log('Updating asset status by version', {
                                groupId: groupId,
                                assetId: assetId,
                                version: params.version,
                                status: status
                            });
                        }
                        else {
                            url = this.getAPIUrl({
                                context: context,
                                pathname: "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/minorVersions/").concat(params.minorVersion, "/status")
                            });
                            log('Updating asset status by minor', {
                                groupId: groupId,
                                assetId: assetId,
                                minorVersion: params.minorVersion,
                                status: status
                            });
                        }
                        body = JSON.stringify({ status: status });
                        return [4 /*yield*/, this.fetch(url, { context: context, method: 'PUT', body: body })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.updateMetadata = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url, body;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, metadata = _b.metadata;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = this.getAPIUrl({
                            context: context,
                            pathname: "/api/v2/assets/".concat(groupId, "/").concat(assetId)
                        });
                        body = JSON.stringify(metadata);
                        log('Updating asset metadata', {
                            groupId: groupId,
                            assetId: assetId,
                            metadata: metadata
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context, method: 'PATCH', body: body })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.updateLabels = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url, body;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, version = _b.version, labels = _b.labels;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = this.getAPIUrl({
                            context: context,
                            pathname: "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/").concat(version, "/tags")
                        });
                        body = JSON.stringify(labels.map(function (label) { return ({ value: label }); }));
                        log('Updating asset labels', {
                            groupId: groupId,
                            assetId: assetId,
                            version: version,
                            labels: labels
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context, method: 'PUT', body: body })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.getVersionGroups = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url, response, json;
            var context = _b.context, domain = _b.domain, groupId = _b.groupId, assetId = _b.assetId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = this.getAPIUrl({
                            context: context,
                            pathname: domain
                                ? "/api/v2/portals/".concat(domain, "/assets/").concat(groupId, "/").concat(assetId, "/versionGroups")
                                : "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/versionGroups")
                        });
                        log('Getting asset versionGroups', {
                            domain: domain,
                            groupId: groupId,
                            assetId: assetId
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _c.sent();
                        return [2 /*return*/, json];
                }
            });
        }); };
        _this.getMinorVersions = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var pathname, query, url, response, json;
            var context = _b.context, domain = _b.domain, groupId = _b.groupId, assetId = _b.assetId, status = _b.status;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pathname = domain
                            ? "/api/v2/portals/".concat(domain, "/assets/").concat(groupId, "/").concat(assetId, "/minorVersions")
                            : "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/minorVersions");
                        query = status ? { status: status } : {};
                        url = this.getAPIUrl({ context: context, pathname: pathname, query: query });
                        log('Getting asset minorVersions', {
                            groupId: groupId,
                            assetId: assetId,
                            domain: domain,
                            status: status
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _c.sent();
                        return [2 /*return*/, json];
                }
            });
        }); };
        _this.getVersionsDependencies = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var pathname, url, response, json;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pathname = "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/dependencies");
                        url = this.getAPIUrl({ context: context, pathname: pathname });
                        log('Getting asset versions dependencies', { groupId: groupId, assetId: assetId });
                        return [4 /*yield*/, this.fetch(url, { context: context })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _c.sent();
                        return [2 /*return*/, json];
                }
            });
        }); };
        _this.getVersionsDependents = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var pathname, url, response;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, versionGroups = _b.versionGroups;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pathname = "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/dependents");
                        url = this.getAPIUrl({ context: context, pathname: pathname });
                        log('Getting asset versions dependents', {
                            groupId: groupId,
                            assetId: assetId,
                            versionGroups: versionGroups
                        });
                        return [4 /*yield*/, this.fetch(url, {
                                context: context,
                                method: 'POST',
                                body: JSON.stringify(versionGroups.map(function (versionGroup) { return ({ versionGroup: versionGroup }); }))
                            })];
                    case 1:
                        response = _c.sent();
                        return [2 /*return*/, response.json()];
                }
            });
        }); };
        _this.getLifeCycleStatesActions = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var pathname, url, response, json;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, version = _b.version, _c = _b.include, include = _c === void 0 ? 'statusTransitions' : _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        pathname = "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/").concat(version, "/actions");
                        url = this.getAPIUrl({
                            context: context,
                            pathname: pathname,
                            query: {
                                include: include
                            }
                        });
                        log('Getting asset life cycle states actions', {
                            groupId: groupId,
                            assetId: assetId,
                            version: version
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context })];
                    case 1:
                        response = _d.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _d.sent();
                        return [2 /*return*/, json];
                }
            });
        }); };
        return _this;
    }
    AssetService.prototype.publish = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var context, organizationId, groupId, assetId, version, name, description, dependencies, keywords, type, _a, status, properties, files, allowedAPISpecFormats, pathname, url, formData, headers, response, json;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        context = params.context, organizationId = params.organizationId, groupId = params.groupId, assetId = params.assetId, version = params.version, name = params.name, description = params.description, dependencies = params.dependencies, keywords = params.keywords, type = params.type, _a = params.status, status = _a === void 0 ? 'published' : _a, properties = params.properties, files = params.files, allowedAPISpecFormats = params.allowedAPISpecFormats;
                        pathname = "/api/v2/organizations/".concat(organizationId, "/assets/").concat(groupId, "/").concat(assetId, "/").concat(version);
                        url = this.getAPIUrl({
                            context: context,
                            pathname: pathname
                        });
                        log('Creating asset', {
                            organizationId: organizationId,
                            groupId: groupId,
                            assetId: assetId,
                            version: version,
                            type: type,
                            name: name,
                            status: status,
                            dependencies: dependencies
                        });
                        formData = new isomorphic_form_data_1.default();
                        formData.append('name', name);
                        formData.append('type', type);
                        formData.append('status', status);
                        if (description) {
                            formData.append('description', description);
                        }
                        if (keywords) {
                            formData.append('keywords', keywords.toString());
                        }
                        if (dependencies) {
                            formData.append('dependencies', dependencies.reduce(function (accum, current) {
                                return "".concat(accum ? "".concat(accum, ",") : '').concat(current.groupId, ":").concat(current.assetId, ":").concat(current.version);
                            }, ''));
                        }
                        if (properties) {
                            properties.forEach(function (property) {
                                formData.append("properties.".concat(property.key), property.value);
                            });
                        }
                        if (files) {
                            files.forEach(function (file) {
                                if (file.classifier) {
                                    formData.append("files.".concat(file.classifier, ".").concat(file.packaging), file.body);
                                }
                                else {
                                    formData.append("files.".concat(file.packaging), file.body);
                                }
                            });
                        }
                        headers = {
                            'x-sync-publication': (!!params.syncPublication).toString(),
                            'content-type': undefined // needed to let fetch convert content type to multipart
                        };
                        if (allowedAPISpecFormats) {
                            headers['x-allowed-api-spec-formats'] = JSON.stringify(allowedAPISpecFormats);
                        }
                        if (!clientsUtils.isClient()) {
                            headers['content-type'] =
                                "multipart/form-data; boundary=".concat(formData.getBoundary());
                        }
                        return [4 /*yield*/, this.fetch(url, {
                                context: context,
                                method: 'POST',
                                body: formData,
                                headers: headers
                            })];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _b.sent();
                        return [2 /*return*/, json];
                }
            });
        });
    };
    return AssetService;
}(clientsUtils.BaseService));
exports.default = AssetService;
